// Einstieg zum Überspringen des Discover-Onboardings, nur für Aivy-Admins.
// Steht im Assistant-Drawer, weil während des Onboardings ein Backdrop über
// der Seite liegt und nur der Drawer bedienbar ist. Copy bewusst ohne i18n,
// wie die übrigen Admin-Komponenten.
import { usePartnerContext, useUserContext } from '../../../context'
import { useAdminOnboardingSkip } from '../admin-onboarding-skip'

const AdminOnboardingSkipCard = () => {
  const { isAdmin, activeSpace } = useUserContext()
  const { partner } = usePartnerContext()
  const { skip } = useAdminOnboardingSkip({ isAdmin })

  if (!isAdmin || activeSpace?.hasCompletedOnboarding) return null

  const customerName = partner?.display_name || partner?.name || 'den Kunden'

  return (
    <section
      aria-labelledby='admin-onboarding-skip-title'
      className='mx-4 mt-4 rounded-lg bg-yellow-50 p-3 ring-1 ring-inset ring-yellow-200'
    >
      <span className='inline-flex items-center rounded bg-yellow-100 px-1.5 py-0.5 text-[11px] font-medium text-yellow-800'>
        Nur für Aivy-Admins
      </span>
      <h3
        id='admin-onboarding-skip-title'
        className='mt-2 text-sm font-semibold text-yellow-900'
      >
        Onboarding überspringen
      </h3>
      <p className='mt-1 text-xs text-yellow-800'>
        Du siehst Entdecken danach so, als wäre das Onboarding erledigt. Das
        gilt nur für dich und nur in diesem Browser.
      </p>
      <p className='mt-1 text-xs text-yellow-800'>
        Für {customerName} ändert sich nichts. Es wird nichts gespeichert und
        nichts an HubSpot gemeldet.
      </p>
      <button
        type='button'
        onClick={skip}
        className='mt-3 rounded-md bg-yellow-800 px-3 py-1.5 text-xs font-semibold text-white hover:bg-yellow-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-800 focus-visible:ring-offset-2'
      >
        Überspringen
      </button>
    </section>
  )
}

export default AdminOnboardingSkipCard
